import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c7bbbb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page page-table" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "page-table-body" }
const _hoisted_5 = { class: "table-main" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    rowspan: "2",
    class: "time"
  }, "発表日時"),
  /*#__PURE__*/_createElementVNode("td", { colspan: "7" }, "特別警報・警報"),
  /*#__PURE__*/_createElementVNode("td", { colspan: "16" }, "注意報")
], -1))
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "table-main" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend" }, null, -1))

import { ref, computed, watch } from 'vue'
import moment from 'moment'
import { useWeatherWarningHistoryStore } from '@/stores/weatherWarningHistoryStore'
import { WEATHER_WARNINGS, WeatherWarningHistoryDicItem } from '@/lib/constants'
import { WeatherWarningHistoryItem } from '@/models/WeatherWarningHistory'
import { useInitDataStore } from '@/stores/initDataStore'
import { Area } from '@/models/WeatherWarning'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const KIND_MARKS = {
  切り替わり: '◇',
  警報から注意報: '■',
  発表: '■',
  継続: '▼',
  解除: '✕',
}

const initDataStore = useInitDataStore()
const weatherWarningHistoryStore = useWeatherWarningHistoryStore()
const areaCode = ref(initDataStore.initData.definitionInfo.alerts.common.areaInfo[0].code)
const tableBodyHeight = ref(window.innerHeight - 300)

const optionsForArea = computed(() => {
  const areaList = initDataStore.initData.definitionInfo.alerts?.common?.areaInfo || []

  return areaList.map((area: Area) => ({ label: area.name, value: area.code }))
})

const historyItems = computed(() => {
  return weatherWarningHistoryStore.weatherWarningHistory.weatherWarningData
})

const getKind = (item: WeatherWarningHistoryItem, dicItem: WeatherWarningHistoryDicItem) => {
  const specialKind = dicItem.specialCode ? item.findKind(dicItem.specialCode) : undefined

  return specialKind || item.findKind(dicItem.code)
}

const getKindClass = (item: WeatherWarningHistoryItem, dicItem: WeatherWarningHistoryDicItem) => {
  const kind = getKind(item, dicItem)

  if (!kind) {
    return ''
  }

  const mark = KIND_MARKS[kind.status as keyof typeof KIND_MARKS]

  if (mark === '✕') {
    return 'cancel'
  }

  if (kind.name.includes('注意報') && mark === KIND_MARKS['切り替わり']) {
    return 'danger'
  }

  if (kind.name.includes('注意報') || (kind.name.includes('警報') && mark === KIND_MARKS['切り替わり'])) {
    return 'warn'
  }

  if (kind.name.includes('特別警報')) {
    return 'special'
  }

  return 'danger'
}

const getKindMark = (item: WeatherWarningHistoryItem, dicItem: WeatherWarningHistoryDicItem) => {
  const kind = getKind(item, dicItem)

  if (!kind) {
    return ''
  }

  return KIND_MARKS[kind.status as keyof typeof KIND_MARKS]
}

const formatTime = (time: string) => {
  return moment(time).format('MM/DD HH:mm')
}

const formatHeadText = (text: string) => {
  return Array.from(text)
    .map(c => c)
    .join('<br />')
}

const tableBodyWrapperStyle = computed(() => {
  return `height: ${tableBodyHeight.value}px`
})

window.addEventListener('resize', () => {
  tableBodyHeight.value = window.innerHeight - 300
})

watch(
  () => areaCode.value,
  () => {
    weatherWarningHistoryStore.fetch(areaCode.value.toString())
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_udc_select = _resolveComponent("udc-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_udc_select, {
          modelValue: areaCode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((areaCode).value = $event)),
          options: _unref(optionsForArea),
          "chobo-style": "search"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _hoisted_6,
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEATHER_WARNINGS), (warning) => {
              return (_openBlock(), _createElementBlock("td", {
                key: warning.code,
                innerHTML: formatHeadText(warning.name),
                class: "label"
              }, null, 8, _hoisted_7))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", {
        style: _normalizeStyle(_unref(tableBodyWrapperStyle)),
        class: "table-body-wrapper"
      }, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historyItems), (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.targetTime
              }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(formatTime(item.targetTime)), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEATHER_WARNINGS), (warning) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: warning.code,
                    class: _normalizeClass([getKindClass(item, warning), "value"])
                  }, _toDisplayString(getKindMark(item, warning)), 3))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ], 4),
      _hoisted_10
    ])
  ]))
}
}

})